
import "./TotpList.css"
import { useState, useEffect, useCallback } from "react"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import commonInterface from "../common/commonInterface"
import TopBar from "../common/TopBar"
import NotiFirstUsage from "./NotiFirstUsage"
import OtpRowItem from "./OtpRowItem"
import TotpEdit from "./TotpEdit"
import SideMenu from "./SideMenu"
import {dummyOtpList} from "./DummyOtpList"

export default function TotpList() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [otpList, setOtpList] = useState([]);
    
    useEffect(function(){
        if (commonInterface.isMobile()) {
            commonInterface.callbackInitOtpList();
        } else {
            setOtpList(dummyOtpList);
        }
    }, []);

    const isShowNotiFirstUsage = otpList.length === 0;

    /**
     * OTP 계정이 추가될때 commonInterface에 의해 호출될 콜백함수를 등록한다.
     * 
     * callbackInitOtpList : 초기화 목록에서 계정이 추가될때마다 실행.
     * callbackAddOtp : 카메라 스캔이후 계정추가 콜백에서 실행.
     */
    const onCompelteAddOtp = useCallback( function(newOtp) {
        setOtpList( (list)=>{return [...list, newOtp]} );
    }, []);
    commonInterface.readyOnCompelteAddOtp(onCompelteAddOtp)

    /**
     * callbackInitOtpList 에서 계정추가가 완료된 이후 or 계정목록이 하나도 없을때
     * 네이티브 로딩바를 종료하기 위해 반드시 실행되어야 함.
     */
    const onCompleteInitOtpList = useCallback( function() {
        commonInterface.hideNativeLoading();
    }, []);
    commonInterface.readyOnCompleteInitOtpList(onCompleteInitOtpList)

    const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
    const [editingOtp, setEditingOtp] = useState(null);

    const topHeader = {
        title: t('totpList.title'),
        leftIcon: "/images/totp/ui/app-menu.png",
        rightIcon: "/images/totp/ui/chat.png",
    };    
    const handleOpenSideMenu = () => {
        console.log("handleCloseSideMenu Open ")
        setIsSideMenuOpen(true);
    };
    const handleCloseSideMenu = () => {
        console.log("handleCloseSideMenu Close ")
        setIsSideMenuOpen(false);
    };
    const handelVanillaLinkMainMenu = ()=>{
        navigate('/linkto/linkmain')        
    };
    const handleManualMenu = ()=>{
        navigate('/vtotp/manual');
    }
    
    const handleEditOtp = (otpRow) => {
        setEditingOtp(otpRow);
    };

    const handleSaveOtp = (updatedOtp) => {
        const newList = otpList.map(otp =>
            otp.mSecret === updatedOtp.mSecret ? updatedOtp : otp
        );
        setOtpList(newList);
        setEditingOtp(null);
        commonInterface.updateOtpListFromReact(newList);
    };

    const handleDeleteOtp = (otpToDelete) => {
        const newList = otpList.filter(otp => otp.mSecret !== otpToDelete.mSecret);
        setOtpList(newList);
        setEditingOtp(null);
        commonInterface.updateOtpListFromReact(newList);
    };

    const handleCancelEdit = () => {
        setEditingOtp(null);
    };

    const handleClearComplete = useCallback(function() {
        setOtpList([]);
    }, []);

    /**
     * 모바일 앱으로 OTP 추가를 명령함
     */
    const handleAddOtp = () => {
        if (commonInterface.isMobile()) {
            commonInterface.callbackAddOtp("handleAddOtp");
        }
        else {
            // PC 웹 환경에서는 더미 OTP 추가
            const randomSecret = 'DUMMY' + Math.random().toString(36).substring(2, 10).toUpperCase();
            const dummyOtp = {
                mName: 'Test Account ' + (otpList.length + 1),
                mAccount: 'test' + (otpList.length + 1) + '@example.com',
                mIssuer: 'TestService',
                mSecret: randomSecret,
                mAlgorithm: 'SHA1',
                mDigits: '6',
                mPeriod: '30',
                mIcon: ''
            };
            setOtpList([...otpList, dummyOtp]);
        }
    };

    if (editingOtp) {
        return (
            <TotpEdit
                otpRow={editingOtp}
                onSave={handleSaveOtp}
                onCancel={handleCancelEdit}
                onDelete={handleDeleteOtp}
            />
        );
    }

    return(
        <div className="totp-list-wrapper">
            <SideMenu isOpen={isSideMenuOpen} onClose={handleCloseSideMenu} onClearComplete={handleClearComplete} />
            <TopBar topHeader={topHeader} onLeftClick={handleOpenSideMenu} onRightClick={handelVanillaLinkMainMenu}/>
            <NotiFirstUsage showNotiFirstUsage={isShowNotiFirstUsage} goManual={handleManualMenu} />
            <div className="totp-list-container">
                {otpList.map((otpRow, index) => (
                    <OtpRowItem key={index} otpRow={otpRow} onEdit={handleEditOtp} />
                ))}
            </div>
            <button className="fab-add-button" onClick={handleAddOtp}>
                <img src={`${process.env.PUBLIC_URL}/images/totp/ui/plus_128.png`} alt="Add OTP" />
            </button>
        </div>
    )
}